<nav class="custom-breadcrumbs">
	<ng-container *ngFor="let item of breadcrumbList; let i = index">
		<a *ngIf="i!==breadcrumbList.length-1" [routerLink]="item.path" [queryParams]="item.params || undefined"
			class="custom-breadcrumb-item">
			{{ item.name }}
		</a>
		<span *ngIf="i===breadcrumbList.length-1" class="custom-breadcrumb-item active-breadcrumb">
			{{ item.name }}
		</span>
	</ng-container>
</nav>